import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { EmergencyContact } from '@/types/person';

const basePath = '/api/dugout/emergency_contact';
export const emergencyContactRepository = createRepository<EmergencyContact, EmergencyContact>(
  basePath
);

const EmergencyContactRepository = () => {
  const { host } = useContext(AppContext);
  const { create, update, delete: _delete } = emergencyContactRepository;

  return {
    createEmergencyContact: (data: Partial<EmergencyContact>) => create({ host, data }),
    updateEmergencyContact: (id: string, data: Partial<EmergencyContact>) =>
      update({ host, id, data }),
    deleteEmergencyContact: (id: string) => _delete({ host, id })
  };
};

export default EmergencyContactRepository;
